import { AccordionFilterItem } from "@/components/accordion/Accordion";
import AutoCompletePerson from "@/components/autocomplete/AutoCompletePerson";
import AppliedFilterItem from "@/components/filter/AppliedFilterItem";

interface ReviewThreadOwnerFilterProps {
  ownerUserId?: string;
  ownerDisplayName?: string;
  onOwnerChange: (owner?: { id: string; name: string }) => void;
}

export default function ReviewThreadOwnerFilter({
  ownerUserId,
  ownerDisplayName,
  onOwnerChange,
}: ReviewThreadOwnerFilterProps) {
  return (
    <AccordionFilterItem
      title="Person"
      value="review-thread-owner"
      isActive={!!ownerUserId}
    >
      {ownerUserId && ownerDisplayName ? (
        <div className="c-applied-filter-group mb-3">
          <AppliedFilterItem
            label={ownerDisplayName}
            removeFilterHandler={() => onOwnerChange(undefined)}
          />
        </div>
      ) : null}
      <AutoCompletePerson
        sizeSmall
        clearAfterSelection
        placeholder="Søg på person ..."
        onSelectedItemChange={({ selectedItem }) => {
          if (selectedItem?.id && selectedItem.id !== "first") {
            onOwnerChange({
              id: selectedItem.id,
              name: String(selectedItem.header ?? selectedItem.id),
            });
          }
        }}
      />
    </AccordionFilterItem>
  );
}
